import { Component, Input, OnInit } from '@angular/core';
import { Components } from '@ionic/core'

@Component({
  selector: 'center-modal',
  templateUrl: './center-modal.component.html',
  styleUrls: ['./center-modal.component.scss']
})
export class CenterModalComponent implements OnInit {

  @Input() modal: Components.IonModal;

  @Input() style: string

  constructor() { }

  ngOnInit(): void {
  }

  dismissModal() {
    this.modal.dismiss()
  }

}
